import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import ReceiptRowM from "./_gears/ReceiptRowM";
import { SysConfig } from "__SYSDefault/Config";
import ReceiptRowW from "./_gears/ReceiptRowW";

/**
 * @augments {Component<Props, State>}
 */
class ReceiptRow extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ReceiptRow.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <ReceiptRowM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <ReceiptRowW {...this.props} />
    });
  }

}

export default observer(ReceiptRow);
